/* Tools Torque v2 – homepage interactions. Vanilla JS, no dependencies. Re-inits in the theme editor. */
(function () {
  'use strict';
  var doc = document.documentElement;
  doc.classList.add('tah-js');
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- hero slider ---------- */
  function initHero(root) {
    if (!root || root.dataset.tahInit) return; root.dataset.tahInit = '1';
    var slides = [].slice.call(root.querySelectorAll('.tah-slide'));
    var dots = [].slice.call(root.querySelectorAll('.tah-dot'));
    if (slides.length < 2) return;
    var ms = (parseInt(root.dataset.autoplay, 10) || 6) * 1000, cur = 0, timer = null;
    root.style.setProperty('--tah-autoplay', ms / 1000 + 's');
    function go(n) {
      slides[cur].classList.remove('is-on'); slides[cur].setAttribute('aria-hidden', 'true');
      if (dots[cur]) dots[cur].classList.remove('is-on');
      cur = (n + slides.length) % slides.length;
      dots.forEach(function (d, i) { d.classList.toggle('is-done', i < cur); d.setAttribute('aria-current', i === cur ? 'true' : 'false'); });
      slides[cur].classList.add('is-on'); slides[cur].removeAttribute('aria-hidden');
      var d = dots[cur]; if (d) { d.classList.remove('is-done'); void d.offsetWidth; d.classList.add('is-on'); }
      schedule();
    }
    function schedule() { clearTimeout(timer); if (!reduce && root.dataset.autoplay !== '0' && !root.classList.contains('is-paused')) timer = setTimeout(function () { go(cur + 1); }, ms); }
    dots.forEach(function (d, i) { d.addEventListener('click', function () { go(i); }); });
    var p = root.querySelector('[data-tah-prev]'), nx = root.querySelector('[data-tah-next]');
    if (p) p.addEventListener('click', function () { go(cur - 1); });
    if (nx) nx.addEventListener('click', function () { go(cur + 1); });
    root.addEventListener('mouseenter', function () { root.classList.add('is-paused'); clearTimeout(timer); });
    root.addEventListener('mouseleave', function () { root.classList.remove('is-paused'); schedule(); });
    root.addEventListener('focusin', function () { root.classList.add('is-paused'); clearTimeout(timer); });
    var x0 = null;
    root.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    root.addEventListener('touchend', function (e) { if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 50) go(cur + (dx < 0 ? 1 : -1)); x0 = null; }, { passive: true });
    root._tahGo = go;
    schedule();
  }

  /* ---------- countdown (to a merchant-set end date) ---------- */
  function initCountdown(el) {
    if (!el || el.dataset.tahInit) return; el.dataset.tahInit = '1';
    var end = Date.parse((el.dataset.end || '').replace(' ', 'T'));
    var wrap = el.closest('[data-tah-cd-wrap]') || el;
    if (isNaN(end)) { wrap.hidden = true; return; }
    var parts = { d: el.querySelector('[data-d]'), h: el.querySelector('[data-h]'), m: el.querySelector('[data-m]'), s: el.querySelector('[data-s]') };
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function tick() {
      var t = Math.floor((end - Date.now()) / 1000);
      if (t <= 0) { wrap.hidden = true; clearInterval(iv); return; }
      var d = Math.floor(t / 86400); t -= d * 86400; var h = Math.floor(t / 3600); t -= h * 3600; var m = Math.floor(t / 60); var s = t - m * 60;
      parts.d.textContent = d; parts.h.textContent = pad(h); parts.m.textContent = pad(m); parts.s.textContent = pad(s);
    }
    var iv = setInterval(tick, 1000); tick();
  }

  /* ---------- tabs ---------- */
  function initTabs(root) {
    if (!root || root.dataset.tahInit) return; root.dataset.tahInit = '1';
    var tabs = [].slice.call(root.querySelectorAll('[role="tab"]'));
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { select(i); });
      t.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); var n = (i + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length; select(n); tabs[n].focus(); }
      });
    });
    function select(i) {
      tabs.forEach(function (t, j) {
        var on = i === j; t.setAttribute('aria-selected', on); t.tabIndex = on ? 0 : -1;
        var p = document.getElementById(t.getAttribute('aria-controls'));
        if (p) { p.hidden = !on; if (on && !reduce) { p.classList.remove('is-enter'); void p.offsetWidth; p.classList.add('is-enter'); } }
      });
    }
  }

  /* ---------- segmented finder ---------- */
  function initSeg(root) {
    if (!root || root.dataset.tahInit) return; root.dataset.tahInit = '1';
    var btns = [].slice.call(root.querySelectorAll('.tah-seg button')), knob = root.querySelector('.tah-seg__knob');
    function place(b) { if (!knob || !b) return; knob.style.left = b.offsetLeft + 'px'; knob.style.top = b.offsetTop + 'px'; knob.style.width = b.offsetWidth + 'px'; knob.style.height = b.offsetHeight + 'px'; }
    function set(b) {
      btns.forEach(function (o) {
        var on = o === b; o.setAttribute('aria-pressed', on);
        var l = document.getElementById(o.getAttribute('aria-controls')); if (l) l.hidden = !on;
      });
      place(b);
    }
    btns.forEach(function (b) { b.addEventListener('click', function () { set(b); }); });
    var first = btns.filter(function (b) { return b.getAttribute('aria-pressed') === 'true'; })[0] || btns[0];
    requestAnimationFrame(function () { place(first); });
    window.addEventListener('resize', function () { place(btns.filter(function (b) { return b.getAttribute('aria-pressed') === 'true'; })[0]); });
  }

  /* ---------- reveal + count-up ---------- */
  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (es) {
    es.forEach(function (en) {
      if (!en.isIntersecting) return;
      var el = en.target;
      if (el.classList.contains('tah-rv')) {
        var sib = [].slice.call(el.parentElement.children).filter(function (c) { return c.classList.contains('tah-rv'); });
        el.style.transitionDelay = Math.max(0, sib.indexOf(el)) * 70 + 'ms';
        el.classList.remove('is-pre');
        if (el.classList.contains('tah-deal')) el.classList.add('is-in');
      }
      if (el.hasAttribute('data-tah-count')) countUp(el);
      io.unobserve(el);
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }) : null;

  function countUp(el) {
    var to = parseFloat(el.dataset.tahCount), pre = el.dataset.prefix || '', suf = el.dataset.suffix || '';
    if (reduce || !to || isNaN(to)) { el.textContent = pre + (isNaN(to) ? el.dataset.tahCount : to) + suf; return; }
    var t0 = null, dur = 1400;
    function f(ts) { t0 = t0 || ts; var k = Math.min(1, (ts - t0) / dur); el.textContent = pre + Math.round(to * (1 - Math.pow(1 - k, 3))) + suf; if (k < 1) requestAnimationFrame(f); }
    requestAnimationFrame(f);
  }

  function initReveal(scope) {
    var els = [].slice.call(scope.querySelectorAll('.tah-rv, .tah-deal, [data-tah-count]'));
    els.forEach(function (el) {
      if (el.classList.contains('tah-deal') && !el.classList.contains('tah-rv')) el.classList.add('tah-rv');
      if (!io || reduce || window.Shopify && Shopify.designMode) { el.classList.remove('is-pre'); el.classList.add('is-in'); return; }
      if (el.classList.contains('tah-rv') && el.getBoundingClientRect().top > window.innerHeight * 0.9) el.classList.add('is-pre');
      else if (el.classList.contains('tah-deal')) el.classList.add('is-in');
      io.observe(el);
    });
    setTimeout(function () { els.forEach(function (el) { el.classList.remove('is-pre'); }); }, 5000);
  }

  /* ---------- quick add (Shopify AJAX cart) ---------- */
  var toast;
  function showToast(msg, err) {
    if (!toast) { toast = document.createElement('div'); toast.className = 'tah-toast'; toast.setAttribute('role', 'status'); toast.innerHTML = '<i aria-hidden="true">✓</i><span></span>'; document.body.appendChild(toast); }
    toast.classList.toggle('is-err', !!err); toast.querySelector('i').textContent = err ? '!' : '✓';
    toast.querySelector('span').innerHTML = msg;
    toast.classList.add('is-on'); clearTimeout(toast._t); toast._t = setTimeout(function () { toast.classList.remove('is-on'); }, 3200);
  }
  function setCount(n) {
    document.querySelectorAll('.js-cart-count,[data-js-cart-count]').forEach(function (c) {
      c.textContent = n; c.setAttribute('data-js-cart-count', n);
      if (c.animate && !reduce) c.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.6)' }, { transform: 'scale(1)' }], { duration: 450 });
    });
  }
  document.addEventListener('submit', function (e) {
    var f = e.target; if (!f.matches || !f.matches('form[data-tah-add]')) return;
    if (!window.fetch) return; e.preventDefault();
    var btn = f.querySelector('button[type="submit"]'), label = btn ? btn.innerHTML : '';
    if (btn) btn.disabled = true;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest' }, body: new FormData(f) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (item) {
        if (btn) { btn.classList.add('is-added'); btn.innerHTML = btn.dataset.added || 'Added'; }
        showToast((item.product_title || 'Item') + ' added to cart <a href="' + root + 'cart">View cart</a>');
        return fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (c) { setCount(c.item_count); document.dispatchEvent(new CustomEvent('tah:cart-updated', { detail: c })); });
      })
      .catch(function (err) { showToast((err && (err.description || err.message)) || 'Could not add to cart. Please try again.', true); })
      .then(function () { setTimeout(function () { if (btn) { btn.disabled = false; btn.classList.remove('is-added'); btn.innerHTML = label; } }, 1800); });
  });

  /* ---------- newsletter success message (Shopify posts back with ?customer_posted=true) ---------- */
  function initNews(scope) {
    if (/customer_posted=true/.test(location.search)) {
      scope.querySelectorAll('[data-tah-nmsg]').forEach(function (m) { m.textContent = m.dataset.ok; });
    }
  }

  function init(scope) {
    scope = scope || document;
    scope.querySelectorAll('[data-tah-hero]').forEach(initHero);
    scope.querySelectorAll('[data-tah-countdown]').forEach(initCountdown);
    scope.querySelectorAll('[data-tah-tabs]').forEach(initTabs);
    scope.querySelectorAll('[data-tah-finder]').forEach(initSeg);
    initReveal(scope); initNews(scope);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var hero = e.target.closest && e.target.closest('[data-tah-hero]');
    if (hero && hero._tahGo) { var i = [].indexOf.call(hero.querySelectorAll('.tah-slide'), e.target.closest('.tah-slide')); if (i > -1) hero._tahGo(i); hero.classList.add('is-paused'); }
  });
})();
